import React from "react"
import zain from "../assets/icons/zain_logo.png"
import xgame from "../assets/icons/logo.png"
import subscribe from "../assets/icons/subscribe.png"
import tick from "../assets/icons/tick.png"
import {Link} from "react-router-dom"
import './Subscribe.scss'

function Subscribe() {
    console.log('inside Subscribe container')
    return (
        <div className="container m-w">
            <div className="columns is-mobile">
                <div className="column is-full">
                    <div className="card">
                        <div className="card-content">
                            <figure className="image z-s m-1">
                                <img src={zain} alt="zain logo"/>
                            </figure>
                            <figure className="image l-s m-2">
                                <img src={xgame} alt="xgame logo"/>
                            </figure>
                            <figure className="image s-s m-5 pb-5">
                                <img src={subscribe} alt="subcribe icon"/>
                            </figure>
                            <div className="columns is-mobile is-multiline">
                                <div className="column is-full v-center p-2">
                                    <span>2.3 SDG/Daily</span>
                                    <Link to="/home" className="button is-rounded btn-main ml-3">Subscribe Now</Link>
                                </div>
                                <div className="column is-full v-center p-2">
                                    <span>14 SDG/Daily</span>
                                    <Link to="/home" className="button is-rounded btn-main ml-3">Subscribe Now</Link>
                                </div>
                                <div className="column is-full v-center p-2">
                                    <span>35 SDG/Daily</span>
                                    <Link to="/home" className="button is-rounded btn-main ml-3">Subscribe Now</Link>
                                </div>
                            </div>
                            <div className="columns is-mobile is-multiline mb-0">
                                <div className="column is-full">
                                    <p><img src={tick} alt="tick" className="f-w mr-1"/>
                                        Unlimited play free PREMIUM games</p>
                                    <p><img src={tick} alt="tick" className="f-w mr-1"/>
                                        Unlimited bandwith & access games</p>
                                    <p><img src={tick} alt="tick" className="f-w mr-1"/>
                                        100% Ad-free version</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Subscribe